<div class="fault-date__container">
  <h4>When did the fault start?</h4>
  <div class="select-fault-data__container" *ngIf="vm.dateString">
    <label for="selected-fault-date" class="checkbox">
      <input
        type="checkbox"
        id="selected-fault-date"
        name="selected-fault-date"
        [formControl]="selectedDateControl"
      />
      <span class="box">
        <svg
          class="checkmark"
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="13"
          viewBox="0 0 17 13"
          fill="none"
        >
          <path
            d="M14.3779 1.5957C14.921 1.07338 15.7987 1.07344 16.3418 1.5957C16.3486 1.60222 16.3535 1.61105 16.3594 1.61816C16.8863 2.14774 16.8801 2.99272 16.3389 3.51367L7.19629 12.3125C6.65317 12.8347 5.77546 12.8349 5.23242 12.3125L0.661133 7.91309C0.112572 7.38512 0.112572 6.52308 0.661133 5.99512C1.20428 5.47241 2.0828 5.47245 2.62598 5.99512L6.21582 9.44727L14.3779 1.5957Z"
            fill="#0065C4"
            stroke="#0065C4"
            stroke-width="0.5"
            stroke-linejoin="round"
          />
        </svg>
      </span>
      <span class="selected-fault-date__label label">{{ vm.dateString }}</span>
    </label>
  </div>
  <dg-app-calendar-picker
    *ngIf="selectedDateControl.value === false"
    [(ngModel)]="selectedDate"
    (ngModelChange)="slotValue = undefined; emitSlotValue()"
    name="calendar"
    [activeDates]="vm.activeDates"
    [showShortenedDays]="isMobile()"
    [maxDate]="vm.maxDate"
    [minDate]="vm.minDate"
    [showTodaySelection]="false"
    [loading]="vm.loading"
    [disabled]="vm.disabled"
    [onlyShowActiveDatesInCurrentMonth]="true"
  />
  <div *ngIf="vm.errorMessage">
    <dgx-components-icon
      size="sm"
      name="circle-exclamation"
      class="error__icon"
    >
    </dgx-components-icon>
    <span class="error-message__label">
      {{ vm.errorMessage }}
    </span>
  </div>
</div>
